import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { AppConfig } from "@config/config";

export interface ApiClientOptions {
  baseUrl: string;
}

export abstract class AxiosClient {
  private axios: AxiosInstance;

  constructor(private options: ApiClientOptions) {
    this.axios = this.createAxiosInstance();
  }

  private createAxiosInstance() {
    const instance = axios.create({
      baseURL: this.options.baseUrl,
      headers: {
        "Content-Type": "application/json"
      }
    });

    // instance.interceptors.request.use(async (config) => {
    //   return config;
    // });

    return instance;
  }

  async sendRequest<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), AppConfig.GLOBAL_TIMEOUT);

    const response = await this.axios.request<T>({
      ...config,
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    return response;
  }
}
